import { useTypedSelector } from "@/hooks";
import { useFetchEmailPreviewQuery } from "@/services";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { FiMaximize2, FiMinimize2 } from "react-icons/fi";


function convertToObject(str) {
  try {
    return JSON.parse(str);
  } catch (error) {
    console.error("Invalid JSON string:", error);
    return null;
  }
}

const EmailPreview = ({
  offerId,
  companyId,
  refreshTrigger,
  handleSubmit,
  activeKey,
}) => {
  const { search } = useLocation();
  const isRevised = search === "?mode=revise";

  const { offer_annual } = useTypedSelector((state) => state?.offers);
  const typeKey = offer_annual ? "annual" : "monthly";

  const [isExpanded, setIsExpanded] = useState(false);

  const {
    data: htmlContent,
    error,
    isLoading,
    refetch,
  } = useFetchEmailPreviewQuery(
    { company_id: companyId, id: offerId, type: typeKey },
    {
      skip: !offerId || !companyId,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (activeKey == "7") {
      (async () => {
        await handleSubmit();
        refetch();
      })();
    }
  }, [activeKey]);

  useEffect(() => {
    if (offerId && companyId) {
      refetch();
    }
  }, [refreshTrigger, offerId, companyId, refetch]);

  const handleDownload = async () => {
    const token = localStorage.getItem("tokens");
    const jsonObject = convertToObject(token);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/company/${companyId}/offer/${offerId}/email-page/pdf/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/pdf",
            Authorization: `Bearer ${jsonObject.access}`,
          },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Offer_${offerId}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      {/* Email Preview Container */}
      <div className="relative border-b h-80">
        {/* Scrollable Content */}
        <div className="p-4 h-full overflow-auto">
          {isLoading && !htmlContent?.data?.body ? (
            <p className="text-center text-gray-500">Loading...</p>
          ) : (
            <div className="emailPreview">
              <div
                dangerouslySetInnerHTML={{
                  __html: htmlContent?.data?.body,
                }}
              />
            </div>
          )}
        </div>

 {/* Expand Button (fixed relative to container) */}
        <button
          onClick={() => setIsExpanded(true)}
          className="absolute w-10 h-10 flex items-center justify-center bottom-3 bg-themeBlue shadow right-5 z-10 text-gray-200 p-2 rounded-full hover:text-white hover:bg-themeBlue transition"
          title="Expand preview"
        >
          <FiMaximize2 />
        </button>
      </div>

      {/* Full Screen Modal */}
      {isExpanded && (
        <div style={{ zIndex: 1000 }} className="fixed inset-0 z-50 bg-black bg-opacity-70">
          <div className="relative bg-white w-full h-full overflow-auto p-6">
            {/* Close Button */}
            <button
              onClick={() => setIsExpanded(false)}
              // className="absolute top-4 right-4 text-gray-600 hover:text-black text-xl"
              className="absolute top-4 right-4  w-10 h-10 flex items-center justify-center  bg-themeBlue shadow z-10 text-gray-200 p-2 rounded-full hover:text-white hover:bg-themeBlue transition"

            >
              <FiMinimize2 />
            </button>

            {/* Full Email Content */}
            <div
              className="emailPreview"
              dangerouslySetInnerHTML={{
                __html: htmlContent?.data?.body,
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EmailPreview;
